import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const menuSlice = createSlice({
  initialState: {
    collapsed: undefined as boolean | undefined,
  },
  name: 'menu',
  reducers: {
    /** Sets the collapsed state; `undefined` returns to the default for the screen size. */
    toggle: (state, action: PayloadAction<boolean | undefined>) => {
      return {
        collapsed: action.payload,
      }
    },
  },
})


export const { toggle } = menuSlice.actions
